import { prefersReducedMotion } from '@theme/utilities';

/**
 * Cross-fades the home page hero into the featured collection as the hero scrolls
 * out of view, so the two sections hand off to each other instead of each fading
 * in independently.
 */
function initHeroHandoff() {
  if (prefersReducedMotion()) return;

  const hero = document.getElementById('shopify-section-hero_jVaWmY');
  const productList = document.getElementById('shopify-section-product_list_fa6P9H');

  if (!hero || !productList) return;

  let ticking = false;

  function update() {
    ticking = false;

    const heroRect = hero.getBoundingClientRect();
    const distance = heroRect.height || 1;

    // 0 when the hero still fills the viewport, 1 once it has fully scrolled past the top.
    const progress = Math.min(Math.max((window.innerHeight - heroRect.bottom) / distance, 0), 1);

    hero.style.opacity = String(1 - progress);
    hero.style.translate = `0 ${(-progress * 40).toFixed(2)}px`;

    productList.style.opacity = String(progress);
    productList.style.translate = `0 ${((1 - progress) * 40).toFixed(2)}px`;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
}

initHeroHandoff();
